import moment from "moment";
import { displayDateFormat } from "../../../utils/helpers";

export const l1Columns = ({ tableData, extraColumns = [] }) => [
  ...extraColumns,
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (props) => {
      if (!props?.row?.original?.submittedOn) {
        return "-";
      }
      return (
        <div>
          {moment(
            props?.row?.original?.submittedOn).format(displayDateFormat)}
          {/* {props?.row?.original?.submittedOn} */}
        </div>
      );
    },
  },
  {
    Header: "Requested Amount(₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.row?.original?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount ? Number(amount).toFixed(2) : "-";
    },
  },
  {
    Header: "Approved Amount(₹)",
    accessor: "approvedAmount",
    Cell: (rowData) => {
      const value = rowData?.row?.original?.approvedAmount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount ? Number(amount).toFixed(2) : "-";
    },
  },

  {
    Header: "Status",
    accessor: "Approved",
    Cell: () => {
      return <div className={"text-[var(--successGreen)]"}>Approved</div>;
    },
  },
  // {
  //   Header: "Approved",
  //   accessor: "approvedAmount",
  //   Cell: (props) => {
  //     const value = props?.row?.original?.approvedAmount;
  //     if (!value) {
  //       return "-";
  //     }
  //     return <div className={"text-[var(--successGreen)]"}>{value}</div>;
  //   },
  // },
];
